<template>
  <div class="loader-container">
    <div class="loader"></div>
  </div>
</template>

<script>
export default {
  name: 'Loader'
}
</script>

<style scoped>
.loader-container {
  background: rgba(0,0,0,0.3); /* Semi-transparent black background */
  padding: 1em;
  position: absolute;
  top: 50%;
  left: 50%;
  /* Center the container using transform */
  transform: translate(-50%, -50%);
  z-index: 9999; /* Ensure it appears above other elements like the map */
  border-radius: 10px;
}

.loader {
  border: 3px solid var(--gray);    /* Light gray border */
  border-top: 3px solid var(--yellow); /* Blue border for the spinning effect */
  border-radius: 50%;
  width: 30px;   /* Smaller width */
  height: 30px;  /* Smaller height */
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
